module.exports = __webpack_public_path__ + "img/29.b014e241.png";